import React from 'react';
import ReactLinkedStateMixin from 'react-addons-linked-state-mixin';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Checkbox, Heading } from '@wix/wix-base-ui';
import * as core from '#packages/core';
import { translate } from '#packages/i18n';
import constants from '#packages/constants';
import * as panels from '#packages/panels';
import * as stateManagement from '#packages/stateManagement';
import { EditableUrl } from '@wix/wix-base-ui';
import { button as BaseUiButton } from '#packages/baseUI';
import * as coreBi from '#packages/coreBi';
import * as util from '#packages/util';

import type { BiEventDefinition } from 'types/bi';
import {
  type SiteWasSavedPanelResult,
  SiteWasSavedPanelCloseSource,
} from '../siteWasSavedPanel';

enum BiActions {
  ClickClose = 'click_close',
  ClickPreview = 'click_preview',
  ClickDone = 'click_done',
  ClickOutside = 'click_outside',
  ClickEscapeKeyboard = 'click_escape_keyboard',
  ClickEnterKeyboard = 'click_enter_keyboard',
}

// eslint-disable-next-line react/prefer-es6-class
export default createReactClass({
  displayName: 'customTemplateSiteWasSavedPanel',
  mixins: [ReactLinkedStateMixin, core.mixins.editorAPIMixin], //eslint-disable-line react/no-deprecated
  propTypes: {
    isFirstSave: PropTypes.bool,
    isMockSave: PropTypes.bool,
    overrideTitle: PropTypes.string,
    overrideSubtitle: PropTypes.string,
    panelName: PropTypes.string,
    callback: PropTypes.func,
    shouldDisplayInnerPanel: PropTypes.bool,
    dealerViewer: PropTypes.func,
  },
  getInitialState() {
    const state = {
      doNotShowAgain: null as AnyFixMe,
    };

    if (!this.props.isFirstSave) {
      state.doNotShowAgain =
        !!stateManagement.userPreferences.selectors.getSessionUserPreferences(
          constants.USER_PREFS.SAVE.SITE_SAVED_DONT_SHOW_AGAIN,
        )(this.getEditorAPI().store.getState());
    }
    return state;
  },
  onContinueEditingButtonClick(action: BiActions) {
    if (this.state.doNotShowAgain) {
      this.getEditorAPI().store.dispatch(
        stateManagement.userPreferences.actions.setSiteUserPreferences(
          constants.USER_PREFS.SAVE.SITE_SAVED_DONT_SHOW_AGAIN,
          Date.now(),
        ),
      );
    }

    this.close(
      {
        closeSource: SiteWasSavedPanelCloseSource.FooterContinueButton,
      },
      action,
    );
  },
  handleDontShowAgainClicked(isChecked: AnyFixMe) {
    this.setState({ doNotShowAgain: isChecked });

    this.getEditorAPI().bi.event(
      coreBi.events.save.siteWasSavedPanel.SECOND_SAVE_DONT_SHOW_AGAIN_CLICKED,
      {
        toggle: isChecked,
        user_status: '',
      },
    );
  },
  componentDidMount() {
    util.fedopsLogger.interactionEnded('ui_save', {
      paramsOverrides: {
        sourceOfStart: this.props.sourceOfStart,
        sourceOfEnd: this.props.panelName,
      },
    });
  },
  componentWillUnmount() {
    if (this.props.callback) {
      this.props.callback(this.callbackResult);
      this.callbackResult = undefined;
    }
  },
  close(result: SiteWasSavedPanelResult, action: BiActions) {
    this.callbackResult = result;
    this.getEditorAPI().panelManager.closePanelByName(this.props.panelName);

    this.sendBI(coreBi.events.customTemplate.post_save_modal, {
      is_first_template_save: this.props.isFirstSave,
      action,
    });
  },
  getKeyboardShortcuts() {
    const self = this;
    return {
      enter() {
        self.onContinueEditingButtonClick(BiActions.ClickEnterKeyboard);
      },
      esc() {
        self.close(
          {
            closeSource: SiteWasSavedPanelCloseSource.KeyboardEscapeKey,
          },
          BiActions.ClickEscapeKeyboard,
        );
      },
    };
  },

  handleCloseButtonClick() {
    this.close(
      {
        closeSource: SiteWasSavedPanelCloseSource.HeaderCloseButton,
      },
      BiActions.ClickClose,
    );
  },

  handleOuterClick() {
    this.close(
      {
        closeSource: SiteWasSavedPanelCloseSource.OuterOverlay,
      },
      BiActions.ClickOutside,
    );
  },

  sendViewPreviewBI() {
    this.sendBI(coreBi.events.customTemplate.post_save_modal, {
      is_first_template_save: this.props.isFirstSave,
      action: BiActions.ClickPreview,
    });
  },
  sendBI(
    biEvent: BiEventDefinition,
    biFields: Record<string, string | number | boolean>,
  ) {
    this.getEditorAPI().bi.event(biEvent, biFields);
  },

  getPreviewUrl() {
    const siteId = this.getEditorAPI().dsRead.generalInfo.getSiteId();
    const metaSiteId = this.getEditorAPI().dsRead.generalInfo.getMetaSiteId();
    const url = `https://editor.wix.com/html/editor/web/renderer/external_preview/document/${siteId}?metaSiteId=${metaSiteId}&dsOrigin=externalPreview`;

    return url;
  },

  viewYourSite() {
    this.sendViewPreviewBI();

    window.open(this.getPreviewUrl());
  },

  renderHeader() {
    return (
      <div className="site-was-saved-panel-header">
        <Heading appearance="h1">SAVE_Templates_Saved_Modal_Title</Heading>
      </div>
    );
  },

  renderBody() {
    return (
      <div className="site-was-saved-panel-body">
        <div className="address-bar-wrapper">
          <div className="editable-url-wrapper">
            <EditableUrl domain={''} value={this.getPreviewUrl()} isReadOnly />
          </div>
          <BaseUiButton
            className="btn-confirm-secondary"
            label="SAVE_Templates_Saved_Modal_Button_Preview"
            onClick={this.viewYourSite}
          />
        </div>
      </div>
    );
  },

  render() {
    return (
      <panels.frames.CustomPanelFrame
        panelName={this.props.panelName}
        className="custom-template-site-was-saved-panel"
        dataHook="custom-template-site-was-saved-panel"
        onCloseButtonClick={this.handleCloseButtonClick}
        onOuterClick={this.handleOuterClick}
        keyboardShortcuts={this.getKeyboardShortcuts()}
        primaryButtonText={translate('SAVE_Templates_Saved_Modal_Button_Done')}
        onPrimaryButtonClick={() =>
          this.onContinueEditingButtonClick(BiActions.ClickDone)
        }
        sideActions={
          <Checkbox
            key="dontShowAgainCheckbox"
            label="SAVE_Templates_Saved_Modal_Do_Not_Show_Again_Label"
            // @ts-expect-error
            valueLink={{
              value: this.state.doNotShowAgain,
              requestChange: this.handleDontShowAgainClicked,
            }}
            labelAfterSymbol={true}
            className="dont-show-again-checkbox"
          />
        }
      >
        <>
          {this.renderHeader()}
          {this.renderBody()}
        </>
      </panels.frames.CustomPanelFrame>
    );
  },
});
